(function () {
  function initHeader(header) {
    var search = header.querySelector('[data-qe-search]');
    var searchInput = header.querySelector('[data-qe-search-input]');
    var searchOpen = header.querySelector('[data-qe-search-open]');
    var searchClose = header.querySelector('[data-qe-search-close]');
    var menu = header.querySelector('[data-qe-mobile-menu]');
    var menuOpen = header.querySelector('[data-qe-menu-open]');
    var desktopMenus = Array.prototype.slice.call(header.querySelectorAll('.qe-shell-nav__details'));

    function closeMenu() {
      if (!menu || !menuOpen) return;
      menu.classList.remove('is-open');
      menu.hidden = true;
      menu.querySelectorAll('details[open]').forEach(function (details) {
        details.removeAttribute('open');
      });
      menuOpen.setAttribute('aria-expanded', 'false');
      menuOpen.setAttribute('aria-label', 'Open menu');
    }

    function closeDesktopMenus(except) {
      desktopMenus.forEach(function (details) {
        if (details !== except) details.removeAttribute('open');
      });
    }

    function closeSearch() {
      if (!search) return;
      search.classList.remove('is-open');
      search.hidden = true;
      if (searchOpen) searchOpen.focus();
    }

    if (searchOpen && search) {
      searchOpen.addEventListener('click', function () {
        closeMenu();
        search.hidden = false;
        search.classList.add('is-open');
        if (searchInput) searchInput.focus();
      });
    }

    if (searchClose) {
      searchClose.addEventListener('click', closeSearch);
    }

    if (menuOpen && menu) {
      menuOpen.addEventListener('click', function () {
        var isOpen = menuOpen.getAttribute('aria-expanded') === 'true';
        if (isOpen) {
          closeMenu();
          return;
        }

        if (search && !search.hidden) closeSearch();
        menu.hidden = false;
        menu.classList.add('is-open');
        menuOpen.setAttribute('aria-expanded', 'true');
        menuOpen.setAttribute('aria-label', 'Close menu');
      });
    }

    desktopMenus.forEach(function (details) {
      details.addEventListener('toggle', function () {
        if (details.open) closeDesktopMenus(details);
      });
    });

    document.addEventListener('click', function (event) {
      if (!header.contains(event.target)) closeDesktopMenus();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (search && !search.hidden) closeSearch();
      closeDesktopMenus();
      if (menu && !menu.hidden) {
        closeMenu();
        if (menuOpen) menuOpen.focus();
      }
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth > 960) closeMenu();
      if (window.innerWidth <= 960) closeDesktopMenus();
    });
  }

  function init() {
    document.querySelectorAll('[data-qe-header]').forEach(initHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
